<template>
  <div class="v-dashboard-container">
    <template v-if="exibirDashboard">
      <Feedback />
      <Atalhos :usuario="usuario" />

      <div class="row mb-5 dashboard-hero">
        <div
          v-if="exibirAreaBanners"
          class="col-12 col-md-8 dashboard-hero__banner"
        >
          <b-carousel
            v-if="temBanners"
            id="carousel-1"
            :interval="6000"
            :controls="false"
            :indicators="true"
            background="transparent"
          >
            <b-carousel-slide
              v-for="(banner, idx) in banners"
              :key="`banner-${idx}`"
            >
              <template #img>
                <img
                  class="img-fluid w-100 dashboard-banner"
                  :src="banner.rb_url"
                  :alt="banner.rb_titulo"
                  :exibicoes="banner.rb_exibicoes"
                  @click="bannerClick(banner)"
                />
              </template>
            </b-carousel-slide>
          </b-carousel>
          <div
            v-else
            class="dashboard-banner-placeholder"
            aria-hidden="true"
          ></div>
        </div>
        <div
          class="col-12 dashboard-hero__ranking"
          :class="exibirAreaBanners ? 'col-md-4' : 'col-md-12'"
        >
          <RankingElosDuradouros
            :dados="rankingElosDuradouros"
            :carregando="carregandoRankingElosDuradouros"
          />
        </div>
      </div>

      <ValoraCards
        v-if="recursoAtivoConta('VALORA') && recursoAtivoConta('LIVE_CHAT')"
        :cards="cardsValora"
        :carregando="carregandoCardsValora"
        :erro="erroCardsValora"
      />

      <div class="row">
        <div class="col-12 col-md-8 d-flex flex-column" style="gap: 1rem">
          <EstatisticasCampanha
            :dados="cardsCampanha"
            :dadosAgendas="cardsAgendas"
            :dadosNps="cardsNps"
            :agruparNps="true"
            :periodo="filtroPeriodo"
            :datepicker="dateRangePicker"
            :carregando="carregandoDadosPeriodo"
            :exibirCampanhasSemCallback="exibirCampanhasSemCallback"
          >
            <div class="d-flex justify-content-start align-items-center">
              <div
                class="d-flex align-items-center mr-2 border rounded"
                style="
                  background-color: #472282 !important;
                  padding: 0.525rem 0.75rem !important;
                  cursor: pointer;
                "
              >
                <label
                  class="mb-0 mr-3 text-white"
                  style="cursor: pointer; font-size: 0.925rem"
                  for="exibirCampanhasSemCallback"
                  >Sem callback
                </label>
                <InputSwitch
                  inputId="exibirCampanhasSemCallback"
                  v-model="exibirCampanhasSemCallback"
                />
              </div>
              <div>
                <a
                  class="btn btn-sm btn-light"
                  @click.stop.prevent="
                    abrirSelecaoPeriodos('estatisticas_campanha')
                  "
                  style="background: #472282; color: #fff; white-space: nowrap"
                >
                  <span class="font-size-base">{{ textoDataInicial }}</span>
                  <span class="font-size-base">{{ textoDataFinal }}</span>
                </a>
                <date-range-picker
                  ref="campanha_picker"
                  opens="left"
                  :always-show-calendars="false"
                  :ranges="dateRangePicker.periodos"
                  :locale-data="dateRangePicker.localizacao"
                  :auto-apply="true"
                  v-model="dateRangePicker.dataInicioFim"
                  @select="periodoSelecionado"
                  class="pt-0"
                ></date-range-picker>
              </div></div
          ></EstatisticasCampanha>
          <div
            class="w-100"
            v-if="graficoDiario.series_whatsapp && graficoDiario.series_sms"
          >
            <GraficoLinha
              :total_whatsapp="graficoDiario.total_whatsapp"
              :total_sms="graficoDiario.total_sms"
              :series_whatsapp="graficoDiario.series_whatsapp"
              :series_sms="graficoDiario.series_sms"
              :total_aglutinado="graficoDiario.total_aglutinado"
              :total_aglutinado_series="graficoDiario.total_aglutinado_series"
              titulo="Mensagens"
              tipo="data"
              :periodo="filtroPeriodo"
              :carregando="!exibirGraficos"
              ref="graficoLinha"
              ><div class="d-flex justify-content-start align-items-center">
                <a
                  class="btn btn-sm btn-light w-100"
                  @click.stop.prevent="abrirSelecaoPeriodos"
                  style="background: #472282; color: #fff; white-space: nowrap"
                >
                  <span class="font-size-base">{{ textoDataInicial }}</span>
                  <span class="font-size-base">{{ textoDataFinal }}</span>
                </a>
                <date-range-picker
                  ref="picker"
                  opens="left"
                  :always-show-calendars="false"
                  :ranges="dateRangePicker.periodos"
                  :locale-data="dateRangePicker.localizacao"
                  :auto-apply="true"
                  v-model="dateRangePicker.dataInicioFim"
                  @select="periodoSelecionado"
                ></date-range-picker></div
            ></GraficoLinha>
          </div>
          <!-- WEL-5195: o grafico so monta com as series em maos. Sem este
          esqueleto o card simplesmente nao existe ate a resposta chegar, e
          a tela da a sensacao de travamento. -->
          <div v-else class="w-100">
            <div class="card card-custom gutter-b dashboard-esqueleto">
              <v-overlay :value="true" :absolute="true">
                <v-progress-circular
                  indeterminate
                  size="32"
                  color="#462181"
                  width="2"
                ></v-progress-circular>
              </v-overlay>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 timeline-container">
          <div
            class="timeline-container__inner d-flex flex-column"
            style="gap: 25px"
          >
            <Timeline
              variant="compact"
              class="flex-grow-1"
              style="min-height: 0"
              :lista="timeline.lista"
              :cursor-inicial="timeline.proximoCursor"
              :carregando="!exibirTimeline"
              @expandir="$refs.modalTimeline.abrir()"
            />
            <EstatisticasCredito
              :dados="cards"
              :plano="tipoPlanoConta"
              :carregando="carregandoDadosPeriodo"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="alert alert-success" role="alert">
        O Dashboard está oculto para otimizar o carregando do sistema no modo
        Super Administrador. Se deseja visualizar o Dashboard
        <a href="javascript:;" class="alert-link" @click="ativarDashboard"
          >clique aqui</a
        >.
      </div>
    </template>

    <!-- Timeline expandida da propria conta (botao expandir do card). -->
    <ModalTimeline
      ref="modalTimeline"
      :lista="timeline.lista"
      :cursor-inicial="timeline.proximoCursor"
    />
  </div>
</template>

<script>
window.chatwootLaunchForSupport();
window.addEventListener("chatwoot:ready", function () {
  const usuario = JSON.parse(localStorage.getItem("usuario"));
  window.$chatwoot.setLabel("Painel-Interno");
  window.$chatwoot.setUser(usuario.login, {
    name: usuario.nome + " | " + usuario.cliente,
    email: usuario.login,
    phone_number: usuario.celular,
    company_name: usuario.conta,
    identifier_hash: usuario.hash_chatwoot,
    description: usuario.cliente
  });

  try {
    const exapnded_text = document.getElementById(
      "woot-widget--expanded__text"
    );
    if (exapnded_text) exapnded_text.style.display = "none";
    const widget_bubble_icon = document.getElementById(
      "woot-widget-bubble-icon"
    );
    if (widget_bubble_icon) widget_bubble_icon.style.margin = "14px";
    const widget_bubble = document.querySelector(".woot-widget-bubble");
    if (widget_bubble) {
      widget_bubble.style.height = "unset";
      widget_bubble.title = "Fale com o time Wellon";
      widget_bubble.style.backgroundColor = "#472282";
    }
    const woot_bubble = document.querySelector(".woot-widget-bubble");
    if (woot_bubble) woot_bubble.classList.add("toggled-woot");
  } catch (error) {
    console.log(error);
  }
});

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import EstatisticasCredito from "./dashboard/EstatisticasCredito.vue";
import Feedback from "./feedback/Feedback.vue";
import DateRangePicker from "vue2-daterange-picker";

import { mapGetters } from "vuex";
import ApiService from "@/core/services/api.service";
import { buscarCardsDashboard } from "@/core/services/valora-api.service";
import moment from "moment-timezone";
import EstatisticasCampanha from "./dashboard/EstatisticasCampanha.vue";
import Timeline from "./dashboard/Timeline.vue";
import ModalTimeline from "./conta/central/ModalTimeline.vue";
import GraficoLinha from "./dashboard/GraficoLinha.vue";
import Atalhos from "./dashboard/Atalhos.vue";

import InputSwitch from "primevue/inputswitch";
import RankingElosDuradouros from "./dashboard/RankingElosDuradouros.vue";
import ValoraCards from "./dashboard/ValoraCards.vue";

export default {
  name: "dashboard",
  components: {
    Feedback,
    EstatisticasCredito,
    EstatisticasCampanha,
    Timeline,
    ModalTimeline,
    DateRangePicker,
    GraficoLinha,
    Atalhos,
    InputSwitch,
    RankingElosDuradouros,
    ValoraCards
  },
  beforeMount() {
    const exibirDashboard = localStorage.getItem("exibirDashboard");

    if (exibirDashboard === null) {
      localStorage.setItem("exibirDashboard", false);

      if (!this.isAdmin) {
        localStorage.setItem("exibirDashboard", true);
        this.exibirDashboard = true;
      }
    } else {
      this.exibirDashboard = JSON.parse(exibirDashboard);
    }

    const datas = this.obterDatas();

    this.dateRangePicker.dataInicioFim.startDate = datas.ultimos3Dias;
    this.dateRangePicker.dataInicioFim.endDate = datas.hoje;

    this.textoDataInicial = "";
    this.textoDataFinal =
      datas.ultimos3Dias.format("DD/MM/YYYY") +
      " - " +
      datas.hoje.format("DD/MM/YYYY");

    this.dateRangePicker.periodos = {
      Hoje: [datas.hoje.toDate(), datas.hoje.toDate()],
      Ontem: [datas.ontem.toDate(), datas.ontem.toDate()],
      "Últimos 3 dias": [datas.ultimos3Dias.toDate(), datas.hoje.toDate()],
      "Última semana": [datas.ultimaSemana.toDate(), datas.hoje.toDate()],
      "Mês atual": [datas.inicioMesAtual.toDate(), datas.fimMesAtual.toDate()],
      "Mês anterior": [
        datas.inicioMesAnterior.toDate(),
        datas.fimMesAnterior.toDate()
      ],
      "Últimos 30 Dias": [datas.ultimos30Dias.toDate(), datas.hoje.toDate()],
      "Últimos 3 meses": [datas.ultimos3Meses.toDate(), datas.hoje.toDate()],
      "Últimos 6 meses": [datas.ultimos6Meses.toDate(), datas.hoje.toDate()],
      "Últimos 12 meses": [datas.ultimos12Meses.toDate(), datas.hoje.toDate()]
    };

    const usuario = JSON.parse(localStorage.getItem("usuario"));
    this.atalhos = usuario.atalhos;
    this.usuario.atalhos = usuario.atalhos.sort(
      (a, b) => a.upa_ordem - b.upa_ordem
    );
  },
  data() {
    return {
      atalhos: [],
      carregandoDadosPeriodo: false,
      dateRangePicker: {
        dataInicioFim: {
          startDate: null,
          endDate: null
        },
        periodos: {},
        mudouRota: false,
        textoDataInicial: "",
        textoDataFinal: "",
        localizacao: {
          format: "dd/mm/yyyy",
          separator: " - ",
          applyLabel: "Aplicar",
          cancelLabel: "Cancelar",
          fromLabel: "De",
          toLabel: "Para",
          customRangeLabel: "Personalizado",
          weekLabel: "W",
          daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
          monthNames: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro"
          ],
          firstDay: 1
        }
      },
      conta_id: null,
      banners: [],
      carregandoBanners: true,
      conta: {},
      exibirGraficos: false,
      exibirTimeline: false,
      graficoDiario: {
        total: 0,
        series: [],
        series_whatsapp: null,
        series_sms: null
      },
      timeline: {
        titulo: "Timeline",
        lista: [],
        proximoCursor: null
      },
      cards: {
        envio: 0,
        recebimento: 0,
        erro: 0,
        callback: 0,
        limiteCredito: 0,
        saldo: 0,
        usuario: 0,
        campanha: 0
      },
      cardsCampanha: [],
      filtroPeriodo: {
        periodo: {
          value: "U3D",
          text: "Últimos 3 dias"
        },
        dataInicial: null,
        dataFinal: null
      },
      usuario: {
        atalhos: []
      },
      exibirDashboard: false,
      exibirCampanhasSemCallback: false,
      rankingElosDuradouros: {},
      carregandoRankingElosDuradouros: false,
      cardsAgendas: [],
      cardsNps: [],
      cardsValora: {},
      carregandoCardsValora: false,
      erroCardsValora: false,
      cardsValoraRequestId: 0
    };
  },
  mounted() {
    if (this.exibirDashboard) {
      this.inicializarDashboard();
    }

    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
    this.exibirBolhaChatwoot();
  },
  computed: {
    ...mapGetters(["layoutConfig", "isAdmin", "recursoAtivoConta"]),
    tipoPlanoConta() {
      switch (this.conta.tipoPlano) {
        case "POS":
          return "Pós-pago";
        case "PRE":
          return "Pré-pago";
        default:
          return "Nenhum";
      }
    },
    temBanners() {
      return this.banners.length > 0;
    },
    exibirAreaBanners() {
      return this.carregandoBanners || this.temBanners;
    }
  },
  methods: {
    // window.$chatwoot existe antes do SDK montar o DOM da bolha, entao o
    // toggleBubbleVisibility estourava em element.classList quando o
    // mounted() corria primeiro. Se ainda nao estiver pronto, espera o
    // evento chatwoot:ready em vez de chamar as cegas.
    exibirBolhaChatwoot() {
      const mostrar = () => {
        try {
          if (window.$chatwoot) {
            window.$chatwoot.toggleBubbleVisibility("show");
          }
        } catch (e) {
          // Widget indisponivel nao pode derrubar o Dashboard.
        }
      };

      if (window.$chatwoot && document.getElementById("woot-widget-bubble")) {
        mostrar();
        return;
      }

      window.addEventListener("chatwoot:ready", mostrar, { once: true });
    },

    abrirSelecaoPeriodos(picker) {
      switch (picker) {
        case "estatisticas_campanha":
          this.$refs.campanha_picker.togglePicker(true);
          break;
        default:
          this.$refs.picker.togglePicker(true);
          break;
      }
    },
    periodoSelecionado({ startDate: dataInicial, endDate: dataFinal }) {
      this.carregandoDadosPeriodo = true;
      const objPeriodo = this.obterPeriodo(dataInicial, dataFinal);
      const route = this.$route.name;
      switch (route) {
        case "dashboard":
          this.$bus.$emit("atualizar:dashboard", objPeriodo);
          break;
        case "mapeamento-perfil":
          this.$bus.$emit("atualizar:mapeamento-perfil", objPeriodo);
          break;
      }

      this.textoDataInicial = objPeriodo.textoDataInicial;
      this.textoDataFinal = objPeriodo.textoDataFinal;
    },
    async buscarBanners() {
      const response = await ApiService.get("/banner-recurso/conta", "", false);
      if (response.data.conta_id) {
        this.conta_id = response.data.conta_id;
      }
      return response.data.recursos || [];
    },
    bannerClick(banner) {
      const urlAcao = this.obterUrlAcaoBanner(banner);
      const recursoBannerFiderId = 35;
      if (urlAcao) {
        window.open(urlAcao, "_blank", "noopener,noreferrer");
      } else if (banner.recurso_banner_id == recursoBannerFiderId) {
        const usuario = JSON.parse(localStorage.getItem("usuario"));
        window.open(usuario.usu_fider_url, "_blank");
      } else {
        window.$chatwoot.toggle();
      }

      const usuario = JSON.parse(localStorage.getItem("usuario"));
      const agora = new Date().toISOString().slice(0, 19).replace("T", " ");
      ApiService.post(
        "/estatistica",
        {
          contaId: this.conta_id,
          recursoTipoId: 10,
          titulo: `Banner: ${banner.rb_titulo}`,
          descricao: `Cliente: ${usuario.cliente} | Conta: ${usuario.conta} | Login: ${usuario.login}`,
          infoDispositivo: {
            ip: null,
            sistema: null,
            dispositivo: null,
            navegador: null
          },
          uid: this.gerarUID(),
          origemChamada: "Painel Interno - Banner",
          dataInicio: agora,
          dataFim: agora
        },
        { baseURL: process.env.VUE_APP_COMUNICANTE_API }
      );
    },
    obterUrlAcaoBanner(banner) {
      let controle = banner.rb_controle;
      if (!controle) return null;

      if (typeof controle === "string") {
        try {
          controle = JSON.parse(controle);
        } catch (error) {
          return null;
        }
      }

      return controle.url_acao || null;
    },
    gerarUID() {
      return `${Date.now().toString(16)}${Math.floor(Math.random() * 0x100000)
        .toString(16)
        .padStart(5, "0")}`;
    },
    async inicializarDashboard() {
      ApiService.get("/dashboard/periodos").then((response) => {
        this.sltPeriodos = response.data.data.sltPeriodos;
      });

      const periodo = {
        dataInicial: this.dateRangePicker.dataInicioFim.startDate,
        dataFinal: this.dateRangePicker.dataInicioFim.endDate,
        periodo: {
          text: "Últimos 3 dias",
          value: "U3D"
        }
      };

      this.dadosDashboard(periodo);

      const self = this;

      this.$bus.$on("atualizar:dashboard", function (periodo) {
        self.filtroPeriodo = periodo;
        self.dadosDashboard(periodo);
      });

      // Mantém a consulta histórica da Timeline do Dashboard sem filtros ou
      // paginação adicionais. A API continua responsável pelas regras de
      // visibilidade das campanhas; o componente cuida apenas da exibição.
      ApiService.get("/dashboard/timeline", "", false)
        .then((response) => {
          const dados = response.data.data;

          if (dados) {
            this.timeline.lista = dados.timeline || [];
            this.timeline.proximoCursor = dados.proximoCursor || null;
          }
        })
        .finally(() => {
          this.exibirTimeline = true;
        });

      ApiService.post("/dashboard/cards", periodo, null, false).then(
        (response) => {
          const dados = response.data.data;

          if (dados) {
            this.cards = dados.cards;
            this.conta = dados.conta;
          }
        }
      );

      try {
        this.banners = await this.buscarBanners();
      } catch (error) {
        console.error("Erro ao carregar banners:", error);
        this.banners = [];
      } finally {
        this.carregandoBanners = false;
      }
    },
    mergeLineChartData(name_key, wpp_series, sms_series) {
      const series = [];
      const series_wpp = wpp_series;
      const series_sms = sms_series;
      const series_wpp_length = series_wpp.length;
      const series_sms_length = series_sms.length;
      const series_length =
        series_wpp_length > series_sms_length
          ? series_wpp_length
          : series_sms_length;
      for (let i = 0; i < series_length; i++) {
        const serie = {
          x: "",
          y: 0
        };

        if (series_wpp[i]) {
          serie.x = series_wpp[i].x;
          serie.y += +series_wpp[i].y;
        }

        if (series_sms[i]) {
          serie.x = series_sms[i].x;
          serie.y += +series_sms[i].y;
        }

        series.push(serie);
      }

      return {
        name: name_key,
        data: series
      };
    },
    dadosDashboard(periodo) {
      this.exibirGraficos = false;
      const payload = { ...periodo };

      this.buscarCardsValora(periodo);

      ApiService.post("/dashboard/graficos", payload, null, false)
        .then((response) => {
          const dados = response.data.data;

          if (dados) {
            this.graficoDiario.series_whatsapp =
              dados.graficoDiario.series_whatsapp;
            this.graficoDiario.series_sms = dados.graficoDiario.series_sms;
            this.graficoDiario.total_whatsapp =
              dados.graficoDiario.total_whatsapp;
            this.graficoDiario.total_sms = dados.graficoDiario.total_sms;

            const total_series = [
              this.mergeLineChartData(
                "Erros",
                dados.graficoDiario.series_whatsapp.find(
                  (serie) => serie.name === "Erros"
                ).data,
                dados.graficoDiario.series_sms.find(
                  (serie) => serie.name === "Erros"
                ).data
              ),
              this.mergeLineChartData(
                "Recebimentos",
                dados.graficoDiario.series_whatsapp.find(
                  (serie) => serie.name === "Recebimentos"
                ).data,
                dados.graficoDiario.series_sms.find(
                  (serie) => serie.name === "Recebimentos"
                ).data
              ),
              this.mergeLineChartData(
                "Envios",
                dados.graficoDiario.series_whatsapp.find(
                  (serie) => serie.name === "Envios"
                ).data,
                dados.graficoDiario.series_sms.find(
                  (serie) => serie.name === "Envios"
                ).data
              )
            ];

            this.graficoDiario.total_aglutinado =
              +dados.graficoDiario.total_sms +
              dados.graficoDiario.total_whatsapp;
            this.graficoDiario.total_aglutinado_series = total_series;

            this.exibirGraficos = true;
            this.carregandoDadosPeriodo = false;

            if (this.$refs.graficoLinha) {
              setTimeout(() => {
                this.$refs.graficoLinha.updateFromPicker();
              }, 500);
            }
          }
        })
        .finally(() => {
          this.carregandoDadosPeriodo = false;
        });

      this.buscarDadosCardCampanha(periodo);
      this.buscarDadosElosDuradoros();
    },

    async buscarCardsValora(periodo) {
      const requestId = ++this.cardsValoraRequestId;
      this.carregandoCardsValora = true;
      this.erroCardsValora = false;

      const datasForamAjustadas = Object.prototype.hasOwnProperty.call(
        periodo,
        "textoDataFinal"
      );
      const normalizarData = (data) => {
        const valor = moment(data);
        if (datasForamAjustadas) valor.add(3, "hours");
        return valor.format("YYYY-MM-DD");
      };
      const dataInicio = normalizarData(periodo.dataInicial);
      const dataFim = normalizarData(periodo.dataFinal);
      const dias = moment(dataFim).diff(moment(dataInicio), "days") + 1;
      const agrupacao = dias <= 31 ? "dia" : dias <= 120 ? "semana" : "mes";

      try {
        const response = await buscarCardsDashboard({
          data_inicio: dataInicio,
          data_fim: dataFim,
          agrupacao
        });

        if (requestId !== this.cardsValoraRequestId) return;
        this.cardsValora = response.data.cards || {};
      } catch (error) {
        if (requestId !== this.cardsValoraRequestId) return;
        this.cardsValora = {};
        this.erroCardsValora = true;
      } finally {
        if (requestId === this.cardsValoraRequestId) {
          this.carregandoCardsValora = false;
        }
      }
    },

    buscarDadosCardCampanha(periodo) {
      return ApiService.post(
        "/dashboard/cards-campanha",
        {
          periodo: periodo,
          agrupamento: "campanha",
          exibirCampanhasSemCallback: this.exibirCampanhasSemCallback
        },
        null,
        false
      ).then((response) => {
        const dados = response.data.data.campanhas;
        this.cardsAgendas = response.data.data.grafico_agenda;
        this.cardsNps = response.data.data.grafico_nps;

        if (dados) {
          this.cardsCampanha = dados.sort(
            (a, b) => b.percentual - a.percentual
          );
        }
      });
    },

    buscarDadosElosDuradoros() {
      this.carregandoRankingElosDuradouros = true;
      ApiService.get("/dashboard/elos-duradouros", "", false)
        .then((response) => {
          const dados = response.data.data;

          if (dados) {
            this.rankingElosDuradouros = this.ordenarElosPorPontuacao(dados);
          }
        })
        .finally(() => {
          this.carregandoRankingElosDuradouros = false;
        });
    },

    ativarDashboard() {
      localStorage.setItem("exibirDashboard", true);
      this.exibirDashboard = true;
      this.inicializarDashboard();
    },

    ordenarElosPorPontuacao(data) {
      let sortedData = Object.keys(data)
        .sort((a, b) => {
          const pontuacaoA = data[a].conta_atual.posicao
            ? parseInt(data[a].conta_atual.posicao)
            : Number.MAX_SAFE_INTEGER;
          const pontuacaoB = data[b].conta_atual.posicao
            ? parseInt(data[b].conta_atual.posicao)
            : Number.MAX_SAFE_INTEGER;
          return pontuacaoA - pontuacaoB;
        })
        .reduce((obj, key) => {
          obj[key] = data[key];
          return obj;
        }, {});
      return sortedData;
    }
  },

  watch: {
    exibirCampanhasSemCallback: async function () {
      this.carregandoDadosPeriodo = true;
      await this.buscarDadosCardCampanha(this.filtroPeriodo);
      this.carregandoDadosPeriodo = false;
    }
  }
};
</script>
<!-- <script>

</script> -->
<style lang="scss">
// WEL-5194: a coluna direita (Ranking + Timeline) precisa terminar
// exatamente na base da coluna esquerda. Como flex item ela já é
// esticada até a altura da linha, mas o conteúdo dela no fluxo normal
// empurrava a linha pra baixo. Tirando o conteúdo do fluxo (absolute),
// quem dita a altura é só a coluna esquerda; o inner então estica de
// top:0 a bottom:0 e a Timeline (flex-grow-1) ocupa o resto.
// Altura aproximada do card Mensagens, pra que o esqueleto nao provoque
// um salto de layout quando o grafico real entra no lugar.
.dashboard-esqueleto {
  position: relative;
  min-height: 420px;
}

.timeline-container {
  @media (min-width: 768px) {
    position: relative;
    min-height: 600px; // piso, caso a coluna esquerda fique curta
  }
}

.timeline-container__inner {
  @media (min-width: 768px) {
    position: absolute;
    top: 0;
    bottom: 0;
    // acompanha o padding lateral do .col (gutter 25px / 2)
    left: 12.5px;
    right: 12.5px;
  }
}

.dashboard-hero {
  --dashboard-banner-height: 270px;
  align-items: stretch;
}

.dashboard-hero__banner,
.dashboard-hero__ranking {
  display: flex;
}

.dashboard-hero__banner .carousel,
.dashboard-hero__banner .carousel-inner,
.dashboard-hero__banner .carousel-item {
  width: 100%;
  height: var(--dashboard-banner-height);
}

.dashboard-hero__ranking > .card {
  width: 100%;
}

.dashboard-banner-placeholder {
  width: 100%;
  height: var(--dashboard-banner-height);
  border-radius: 8px;
  background: linear-gradient(110deg, #eee 8%, #f5f5f5 18%, #eee 33%);
  background-size: 200% 100%;
  animation: dashboard-banner-loading 1.4s linear infinite;
}

@keyframes dashboard-banner-loading {
  to {
    background-position-x: -200%;
  }
}

.estatistica-mensagens-container {
  height: 500px;
}
.da-menu {
  position: absolute;
  top: 15px;
  right: 25px;
  cursor: pointer;
}
.panel-heading {
  .vac-menu-options {
    right: 30px;
    top: 30px;
  }
  .vac-menu-list {
    padding: 0;
    .vac-menu-item {
      padding: 0;
    }
  }
}

.woot-elements--right {
  background-color: #472282 !important;
}

.dashboard-banner {
  display: block;
  width: 100%;
  height: var(--dashboard-banner-height);
  border-radius: 8px;
  cursor: pointer;
  object-fit: contain;
  object-position: left center;
}

@media (max-width: 767.98px) {
  .dashboard-hero {
    --dashboard-banner-height: 180px;
  }
}

/* ffc107 */
.v-dashboard-container {
  .carousel-indicators li {
    background-color: #ffc107 !important;
  }
  .p-inputswitch .p-inputswitch-slider {
    border-radius: 15px !important;
  }
  .p-inputswitch {
    width: 2.8rem !important;
    height: 1.4rem !important;
  }
  .p-inputswitch .p-inputswitch-slider:before {
    background: #b6b6b6 !important;
    border-radius: 50% !important;
    width: 1.1rem !important;
    height: 1.1rem !important;
    margin-top: -0.54rem !important;
    left: 0.22rem !important;
  }
  .p-inputswitch .p-inputswitch-slider,
  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
    background: #ffffff !important;
  }
  .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:before {
    background: #472282 !important;
  }
  .p-inputswitch.p-focus .p-inputswitch-slider {
    -webkit-box-shadow: 0 0 0 0.1rem rgba(206, 212, 218, 0.5) !important;
    box-shadow: 0 0 0 0.1rem rgba(206, 212, 218, 0.5) !important;
  }
}
</style>
